import $api from "@/frontend/shared/api/axios";

export async function postInviteAnExpert({
  email,
  portfolioCompanyIds
}: {
  email: string;
  portfolioCompanyIds: number[];
}) {
  const res = await $api.post("/organizations/invite/expert", { email, portfolioCompanyIds });
  return res.data.data;
}
